import { render, staticRenderFns } from "./ProductsStats.vue?vue&type=template&id=28ada0f4&scoped=true&"
import script from "./ProductsStats.vue?vue&type=script&lang=js&"
export * from "./ProductsStats.vue?vue&type=script&lang=js&"
import style0 from "./ProductsStats.vue?vue&type=style&index=0&id=28ada0f4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ada0f4",
  null
  
)

export default component.exports